import { Controller } from '@hotwired/stimulus'

export default class NotificationsDropdownController extends Controller {
  static targets = ['container', 'frame']
  static values = { markAllAsReadUrl: String }

  connect() {
    this.boundClickOutside = this.clickOutside.bind(this)
    this.boundHandleEscape = this.handleEscape.bind(this)
  }

  disconnect() {
    this.removeListeners()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const isHidden = this.containerTarget.hasAttribute('hidden')

    if (isHidden) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.containerTarget.removeAttribute('hidden')
    this.reloadFrame()
    this.addListeners()
  }

  close() {
    this.containerTarget.setAttribute('hidden', '')
    this.removeListeners()
    this.markAllAsRead()
  }

  markAllAsRead() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.markAllAsReadUrlValue, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json'
      }
    }).catch(error => {
      console.error('Failed to mark notifications as read:', error)
    })
  }

  reloadFrame() {
    // Reload the frame to get fresh data
    if (this.hasFrameTarget) {
      this.frameTarget.reload()
    }
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  handleEscape(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }

  addListeners() {
    setTimeout(() => {
      document.addEventListener('click', this.boundClickOutside)
      document.addEventListener('keydown', this.boundHandleEscape)
    }, 100)
  }

  removeListeners() {
    document.removeEventListener('click', this.boundClickOutside)
    document.removeEventListener('keydown', this.boundHandleEscape)
  }
}
